import React from 'react';
import { Heading, TypographyColor, TypographyType } from '../../../ui-elements';

interface MapHelperNotificationProps {
    message: string;
    onClose: () => void;
}

/**
 * MapHelperNotification - Displays helper text notification on the map
 */
export const MapHelperNotification: React.FC<MapHelperNotificationProps> = ({
    message,
    onClose,
}) => {
    return (
        <div className="map-cif-type-warning padding-left-right-5 padding-top-bottom-3 rounded">
            <Heading
                title={message}
                type={TypographyType.h5}
                colour={TypographyColor.white}
            />
            <span
                className="material-symbols-outlined color-white cursor-pointer"
                onClick={onClose}
            >
                close
            </span>
        </div>
    );
};
